import state from "./moduleStatusMobileState";
import mutations from "./moduleStatusMobileMutations";
import actions from "./moduleStatusMobileActions";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
};
